import DomainCommon from './common';

const GroupService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/group`,
                resolve, reject
            });
        });
    },
    findById: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/group/${groupId}`,
                resolve, reject
            });
        });
    },
    add(group) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/group`,
                jsonBody: group,
                resolve, reject
            });
        });
    },
    changePlan({groupId, pricePlanId}) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}/changePlan`,
                jsonBody: {pricePlan: {id: pricePlanId}},
                resolve, reject
            });
        });
    },
    update(group) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${group.id}`,
                jsonBody: group,
                resolve, reject
            });
        });
    },
    addPoint({groupId, point}) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}/addCurrentPoint`,
                jsonBody: {
                    point
                },
                resolve, reject
            });
        });
    },
    deleteById(groupId) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchDelete({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}`,
                resolve, reject
            });
        });
    },
    updateMainVip(mainVip, group) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${group.id}/mainVip`,
                jsonBody: mainVip,
                resolve, reject
            });
        });
    },
    plusUseRecord: ({groupId, missionTypeId, period_in_milliseconds, points}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}/plusUseRecord`,
                jsonBody: {missionTypeId, period_in_milliseconds, points},
                resolve, reject
            });
        });
    },
    getGroupLeftCanUse(groupId) {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}/leftCanUse`,
                resolve, reject
            });
        });
    },
};

export default GroupService;



// WEBPACK FOOTER //
// ./src/service/group.js